export default "__VITE_ASSET__DwOR4FW2__"